<template>
  <div style="margin-top:20px">
    <el-form
      ref="form"
      label-width="80px"
      :model="form"
    >
      <el-form-item
        label="标题"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.title"
          :disabled="true"
          @change="(value)=>{form.title = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="副标题"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.subhead"
          type="textarea"
          :rows="3"
          :disabled="true"
          @change="(value)=>{form.subhead = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="编辑者"
        style="margin-right:15px"
      >
        <el-input
          v-model.trim="form.editName"
          :disabled="true"
          @change="(value)=>{form.editName = value.replace(/\s/g,'')}"
        />
      </el-form-item>
      <el-form-item
        label="类别"
        style="margin-right:15px"
      >
        <el-select
          v-model="form.newsType"
          :disabled="true"
        >
          <el-option
            v-for="(v,k) in dicts.newsType"
            :key="k"
            :label="v"
            :value="k"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        label="图片"
        style="margin-right:15px"
      >
        <ImgUpload
          :upload-config="{ lebal: '公告图片', prefix: 'img', form, suffix: 'Url', modal: false }"
          :parent-data="{ isDetail: true }"
        />
      </el-form-item>
      <el-form-item
        label="公告内容"
        prop="content"
        style="margin-right:15px"
      >
        <myEditor
          ref="editor"
          v-model="form.content"
          :disabled="true"
        />
      </el-form-item>
    </el-form>
  </div>
</template>
  <script>
  import request from '@/utils/request'
  import ImgUpload from "@/components/ImgUpload";
  import myEditor from '@/components/MyEditor'
  
  export default {
    name: 'BulletinDetail',
    components: {
      myEditor,
      ImgUpload
    },
    data() {
      return {
        dicts: { isRelease: {}, newsType: {}},
        emptyForm: {},
        form: {
          imgUrl: '',
          title: '',
          content: '',
          editName: '',
          newsType: '',
          ifRelease: '0'
        }
      }
    },
    created() {
      // 保存空表单对象
      this.emptyForm = JSON.parse(JSON.stringify(this.form))
    },
    methods: {
      // 获取页面信息
      getInfo(code, dicts) {
        this.dicts = dicts
        // 查询到数据之前先展示空表单
        this.form = JSON.parse(JSON.stringify(this.emptyForm))
        request({ url: `/ntocc-basic-api/bulletin/${code}`, method: 'get' }).then(response => {
          this.form = response.data
        })
      }
    }
  }
  </script>
  <style lang="scss" scoped>
    .dialog-footer {
      margin-top: 50px;
    }
  </style>
  